import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import MediaWallPreview from './MediaWallPreview';

const MediaWallPreviewPortal = () => {
  const location = useLocation();
  const [mountNode, setMountNode] = useState(null);

  useEffect(() => {
    if (location.pathname !== '/') {
      setMountNode(null);
      return undefined;
    }

    let cancelled = false;
    let tries = 0;
    let host = null;

    const mount = () => {
      if (cancelled) return;
      const sections = Array.from(document.querySelectorAll('main section'));
      const newsSection = sections.find((section) => section.textContent?.includes('Τελευταία Νέα'));

      if (newsSection?.parentNode) {
        host = document.createElement('div');
        host.setAttribute('data-media-wall-preview-portal', 'true');
        newsSection.parentNode.insertBefore(host, newsSection);
        setMountNode(host);
        return;
      }

      tries += 1;
      if (tries < 25) window.setTimeout(mount, 100);
    };

    mount();
    return () => {
      cancelled = true;
      setMountNode(null);
      if (host?.parentNode) host.parentNode.removeChild(host);
    };
  }, [location.pathname]);

  if (!mountNode) return null;
  return createPortal(<MediaWallPreview />, mountNode);
};

export default MediaWallPreviewPortal;
